module.exports = __webpack_public_path__ + "static/media/pencil.e94eda9b.svg";